export const CONTACT = {
  email: "kamalamafoundation@gmail.com",
  phone: "(808) 631-8672",
  address: "3-4684 Kuhio Highway, Lihue, HI 96766",
};

export const CENSUS_URL = "https://hiriskmanagement.com/kauaibusinesses";

export const HOLIDAY_FAIR = {
  name: "Kamalama Holiday Fair",
  date: "Saturday, December 26, 2026",
  dateShort: "December 26, 2026",
  hours: "10:00 AM–10:00 PM",
};

export const IG_REEL_URL = "https://www.instagram.com/reel/DeSHun_vpol/";
export const IG_REEL_EMBED = "https://www.instagram.com/reel/DeSHun_vpol/embed";

export const FEED_PHOTOS = [
  {
    src: "/feed/feed-1.webp",
    alt: "Feed the Community volunteers sharing shakas after a beachside meal distribution",
  },
  {
    src: "/feed/feed-2.webp",
    alt: "Volunteers plating hot meals at a Feed the Community service on Kauaʻi",
  },
  {
    src: "/feed/feed-3.webp",
    alt: "Feed the Community volunteers standing together with trays of shared food",
  },
  {
    src: "/feed/feed-4.webp",
    alt: "Plates of rice, chili and chicken ready to serve at a community meal",
  },
];

export const BOARD_MEMBERS = [
  { name: "Anthony Andrews", role: "President" },
  { name: "Meghann Matsuda", role: "Executive Director" },
  { name: "Opinder Deol", role: "Board Treasurer" },
  { name: "Magdy Rodriguez", role: "Board Secretary" },
];

export const COMMITTEE_LEADS = [
  { name: "Emily Manuel", role: "Vendor Committee Leader" },
  { name: "Farah Aquino", role: "Vendor Committee Leader" },
  { name: "Kalehua Dabin", role: "Setup Crew Committee Leader" },
];

export const VENDOR_CATEGORIES = [
  "Food & beverages",
  "Crafts & art",
  "Merchandise & retail",
  "Community & nonprofit",
  "Keiki & family",
  "Other",
];

export const STAGES = [
  {
    name: "Immediate Community Response",
    detail:
      "Verified emergency resources, community coordination, volunteers, in-kind support and available relief.",
  },
  {
    name: "Business Needs Assessment",
    detail:
      "Kauaʻi business owners complete the business-needs census with HI Risk Management so we can understand the scope of need.",
  },
  {
    name: "Application, Verification & Awards",
    detail:
      "Opens only after the Board approves a written policy, eligibility, verification, award criteria and payment process.",
  },
];

export const RESOURCES_UPDATED_DEFAULT = "October 1, 2026";

export const RESOURCES = [
  {
    cat: "Emergency updates",
    items: [
      ["Kauaʻi Emergency Management Agency", "Official county alerts, shelters and road status", "https://www.kauai.gov/KEMA"],
      ["National Weather Service Honolulu", "Forecasts and warnings", "https://www.weather.gov/hfo/"],
    ],
  },
  {
    cat: "Food and water",
    items: [
      ["Hawaiʻi Foodbank, Kauaʻi", "Food distribution sites and partner pantries", "https://hawaiifoodbank.org/"],
      ["Aloha United Way 211", "Dial 2-1-1 for food, water and local services", "https://www.auw211.org/"],
    ],
  },
  {
    cat: "Shelter and housing",
    items: [
      ["American Red Cross, Hawaiʻi", "Emergency shelter and disaster help", "https://www.redcross.org/local/hawaii.html"],
      ["Kauaʻi Emergency Management Agency", "Current shelter openings", "https://www.kauai.gov/KEMA"],
    ],
  },
  {
    cat: "Power, charging and communication",
    items: [
      ["Kauaʻi Island Utility Cooperative", "Outage map and restoration updates", "https://www.kiuc.coop/"],
    ],
  },
  {
    cat: "Medical and health",
    items: [
      ["Hawaiʻi State Department of Health", "Health advisories and services", "https://health.hawaii.gov/"],
      ["Emergencies", "Call 911", ""],
    ],
  },
  {
    cat: "Government disaster assistance",
    items: [
      ["DisasterAssistance.gov", "Federal assistance, if a declaration applies", "https://www.disasterassistance.gov/"],
      ["Hawaiʻi Emergency Management Agency", "State recovery information", "https://dod.hawaii.gov/hiema/"],
    ],
  },
  {
    cat: "Local nonprofit and mutual aid",
    items: [
      ["Aloha United Way 211", "Referrals to local nonprofits", "https://www.auw211.org/"],
    ],
  },
  {
    cat: "Business recovery",
    items: [
      ["U.S. Small Business Administration", "Disaster loans and recovery help", "https://www.sba.gov/funding-programs/disaster-assistance"],
      ["Hawaiʻi Small Business Development Center", "Free business advising", "https://www.hisbdc.org/"],
      ["Kamalama business-needs census", "Share your business's recovery needs", CENSUS_URL],
    ],
  },
  {
    cat: "Volunteer opportunities",
    items: [
      ["Kamalama Community Membership", "Sign up to hear about volunteer needs", "/get-involved"],
    ],
  },
];

export const FAQ = [
  ["Is Priced Out of Kauaʻi by Lowell a separate nonprofit?", "No. Priced Out of Kauaʻi by Lowell is a program operated by Kamalama Foundation."],
  ["How can local businesses share their recovery needs?", "Kamalama Foundation is working with HI Risk Management on a business-needs census. Please use the census link on this website to share information about the impact Hurricane Lowell has had on your business."],
  ["Is the HI Risk Management census a Kamalama Foundation grant application?", "No. The census helps assess community recovery needs. Completing it does not guarantee funding, create a grant application, or create a right to an award from Kamalama Foundation."],
  ["When will the Foundation open applications for assistance?", "The Foundation will consider a formal application process after reviewing business-needs information, available charitable funds, and community conditions. Before awards are made, the Board will approve and publish final eligibility, verification, priority, award, and payment procedures."],
  ["What is the Foundation's planned first recovery priority?", "Subject to available funds and Board-approved criteria, the planned first recovery priority is to help verified eligible applicants stabilize one month of essential business rent or lease obligations and one month of essential household rent or mortgage obligations where Hurricane Lowell-related business-income loss has created documented unmet need."],
  ["Will every business receive full rent assistance?", "Not necessarily. The Foundation cannot promise a particular award amount or full payment of rent. Awards will depend on available funds, verified eligibility and need, insurance and other aid, the number of qualified applicants, Board-approved caps, and the published priority framework."],
  ["Will the Foundation cover all business losses?", "No. The Foundation does not promise to fully reimburse business losses. If funds remain after rent-first awards, the Board may approve supplemental assistance for other verified essential business or household needs."],
  ["Who approves assistance awards?", "Trained volunteers or staff may help organize applications and request missing information. Final awards are approved by the Board of Directors or a properly authorized Independent Grant Review Committee using Board-approved criteria and conflict-of-interest safeguards."],
  ["Will the Foundation publish updates?", "Yes. Kamalama Foundation posts verified Transparency & Impact Updates every Sunday."],
  ["Is my donation tax-deductible?", "Yes. Kamalama Foundation is a tax-exempt charitable organization recognized under Section 501(c)(3) of the Internal Revenue Code. Contributions are tax-deductible to the extent permitted by law."],
];

export const PRIORITY_FACTORS = [
  "Immediate risk of closure, lease default, eviction, utility shutoff, or insurance lapse",
  "Immediate risk of household displacement from Lowell-related income loss",
  "Verified substantial revenue loss or temporary closure",
  "Unmet rent or housing need after insurance and other aid",
  "Businesses supporting employees or essential local services",
  "Tourism dependence",
  "Uninsured or underinsured need",
];

export const HELP_AREAS = [
  "Immediate response",
  "Recovery outreach",
  "Fundraising",
  "Grant research",
  "Recordkeeping",
  "Communications and media",
  "Holiday Fair",
  "Artist and sponsor outreach",
  "Donated services",
  "Just keep me updated",
];

export const TOPICS = [
  "General question",
  "Business census question",
  "Share a resource",
  "Donate services or sponsor",
  "Holiday Fair",
  "Media",
];

export const DEFAULT_SETTINGS = {
  donation_url: "",
  census_url: CENSUS_URL,
  resources_updated: RESOURCES_UPDATED_DEFAULT,
  stage: 2,
  ledger: null,
  updates: [
    "Immediate response: sharing verified emergency resources for Kauaʻi residents and businesses.",
    "Business-needs census with HI Risk Management is being prepared for Kauaʻi business owners.",
    "Planning underway for the Kamalama Holiday Fair — Saturday, December 26, 2026, 10 AM to 10 PM.",
    "Grant research and outreach to foundations, corporate donors and local partners has begun.",
  ],
};

export const MARQUEE_ITEMS = [
  "Kauaʻi takes care of Kauaʻi",
  "Hurricane Lowell relief",
  "Immediate community response",
  "Business needs census",
  "Sunday transparency updates",
  "Rent-first recovery",
];

export const IMAGES = {
  hero: "https://images.pexels.com/photos/11022065/pexels-photo-11022065.jpeg?auto=compress&cs=tinysrgb&w=1920",
  coastSunset: "https://images.pexels.com/photos/5006572/pexels-photo-5006572.jpeg?auto=compress&cs=tinysrgb&w=1600",
  townHillside: "https://images.unsplash.com/photo-1780324807333-ec3b30e558fe?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  storefront: "https://images.unsplash.com/photo-1647553989271-03ae114283c4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  townStreet: "https://images.unsplash.com/photo-1588652269774-cf644359ef24?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  communityCouple: "https://images.unsplash.com/photo-1778506201036-97b863d20d0f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  communityOutdoors: "https://images.unsplash.com/photo-1778506200921-e095261c73b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  holidayFairPromo: "/holiday-fair-promo.png",
};
